export interface KeywordSet {
	keywords: string[];
}

export interface ParsedKeywords {
	sets: KeywordSet[];
}

/**
 * Parses a keyword criterion string with special delimiters:
 * - Commas (,) separate keywords within a set (OR logic)
 * - Semicolons (;) separate sets (AND logic)
 *
 * Example: "catering kitchen;gourmet kitchen,chef's kitchen"
 * Returns: { sets: [{ keywords: ["catering kitchen"] }, { keywords: ["gourmet kitchen", "chef's kitchen"] }] }
 */
export const parseKeywords = (value: string): ParsedKeywords => {
	if (!value || typeof value !== "string") {
		return { sets: [] };
	}

	// Split by semicolons to get sets (AND logic)
	const setStrings = value.split(";");

	const sets: KeywordSet[] = setStrings
		.map((setString) => {
			// Split by commas to get keywords within set (OR logic)
			const keywords = setString
				.split(",")
				.map((keyword) => keyword.trim()) // Trim whitespace
				.filter((keyword) => keyword.length > 0); // Remove empty strings

			return { keywords };
		})
		.filter((set) => set.keywords.length > 0); // Remove empty sets

	return { sets };
};
